import React from 'react';
import Editor from "@monaco-editor/react";

import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';
import * as SYS from '.';


export const CacheForm = props => {
    const [form] = Antd.Form.useForm();

    const layout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
    };

    const tailLayout = {
        wrapperCol: { span: 18, offset: 6 },
    };

    return (
        <Antd.Form
            {...layout}
            form={form}
            initialValues={props.initialValues}
            onFinish={values => {
                if (props.onSuccess) {
                    props.onSuccess(values);
                }
            }}
            onFinishFailed={(err) => {
                console.log(err);
            }}
        >
            {props.initialValues && props.initialValues.id
                ? <Antd.Form.Item name="id" label="ID">
                    <Antd.Input disabled={true} />
                </Antd.Form.Item>
                : null}
            <Antd.Form.Item
                name="connector"
                label="Connector"
                rules={[{ required: true }]}
            >
                <SYS.ConnectorSelect
                    identificator="code"
                />
            </Antd.Form.Item>
            <Antd.Form.Item
                name="dataset"
                label="Dataset"
                rules={[{ required: true }]}
            >
                <SYS.DatasetSelect
                    identificator="code"
                />
            </Antd.Form.Item>
            <Antd.Form.Item
                name="filters"
                label="Filters"                                
            >
                <Editor
                    height="30vh"
                    defaultLanguage="json"
                    defaultValue="{}"
                />
            </Antd.Form.Item>
            <Antd.Form.Item
                name="staleTime"
                label="Stale time [min]"
                rules={[{ required: true }]}
            >
                <Antd.InputNumber />
            </Antd.Form.Item>
            <Antd.Form.Item
                name="client"
                label="Client-side"
                valuePropName="checked"
            >
                <Antd.Switch />
            </Antd.Form.Item>
            <Antd.Form.Item
                name="server"
                label="Server-side"
                valuePropName="checked"
            >
                <Antd.Switch />
            </Antd.Form.Item>

            <Antd.Form.Item
                {...tailLayout}
                style={{
                    marginTop: 10
                }}
            >
                <Antd.Button
                    type="primary"
                    htmlType="submit"
                >
                    Submit
                </Antd.Button>
            </Antd.Form.Item>
        </Antd.Form >
    );
}